import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  token:null,
  userId:null,
  userEmail:null,
  userFirstName:null,
  userLastName:null,
  isAdmin:false,
  inventoryAccess:false,
  login: () => {},
  logout: () => {},
});
